export default __webpack_public_path__ + "static/media/users-white.bb969c3c.svg";